// TODO move to redux
import { createContext } from 'react';

export const IntegrationFormRefContext = createContext();
